import type { EpgInfo } from '@setplex/tria-api'
import type { EpgRequestParams } from '../index.h'

import { createEvent, createStore, sample } from 'effector'
import { concatById, sortById } from '~/shared/helpers'
import { narrowEpgRequestToNecessary } from '../lib/epg'
import { isValidRange } from '../lib/ranges'
import { fetchEpgInfo, fetchEpgInfoFx } from './fetch'
import { $loaded } from './ranges'

// whole epg matrix, by epg id
export const $epg = createStore<[Map<string, EpgInfo[]>]>([new Map()])

// fetch epg data request from widget
export const fetchEpg = createEvent<EpgRequestParams>()

// for requested range, calculate biggest common unloaded range for all channels
sample({
  clock: fetchEpg,
  source: $loaded,
  filter: (_, requested) =>
    requested.channels.length > 0 && isValidRange(requested.period),
  fn: ([loaded], requested) =>
    narrowEpgRequestToNecessary({ requested, loaded }),
  target: fetchEpgInfo,
})

// fill epg matrix with loaded data
sample({
  clock: fetchEpgInfoFx.done,
  source: $epg,
  fn: ([programs], { params: { epgIds }, result: { epg } }) => {
    for (const id of epgIds) {
      const loaded = programs.get(id)
      const received = epg[id]

      const merged = sortById(concatById(loaded)(received))
      programs.set(id, merged)
    }
    return [programs] as const
  },
  target: $epg,
})
